import { connect } from 'react-redux';
import openProbeDetails from '../../../../api/probeDetails/probeDetailsActions';
import { selectors } from '../../../../root/reading/root';
import GrowthAnalysisTable from '../../../../features/progress/shared/growthAnalysis/GrowthAnalysisTable';
import ProbeDetailsPageContainer from '../../../probeDetails/reading/ProbeDetailsPageContainer';
import { getRowsToRender } from '../../../../utils/shared/growthAnalysisUtils';
import SkillCell from '../../../../components/cell/reading/Cells';
import CommonCellBuilder from '../../../../components/cell/reading/CommonCellBuilder';
import { SS_URL } from '../../../../constants/reading/ApiConstants';

const appSpecificParams = {
    SkillCell,
    CommonCellBuilder,
    ssUrl: SS_URL,
};

const mapStateToProps = state => ({
    location: selectors.getLocation(state),
    resultsByGrades: selectors.getStudentsGrowthAnalysisDataByGrades(state),
    periodObject: selectors.getGrowthAnalysisPeriodObject(state),
    gradeToMeasureMapper: selectors.getGradeToMeasureMapper(state),
    ProbeDetailsPageContainer,
    getRowsToRender,
    appSpecificParams,
});

const mapDispatchToProps = dispatch => ({
    openProbeDetails: resultId => dispatch(openProbeDetails(resultId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GrowthAnalysisTable);
